<script>
import { mapState } from 'vuex';
import Loading from '../../components/loading.vue';
import Cropper from 'cropperjs';
import 'cropperjs/dist/cropper.css';
import Popup from '../../components/mineTable/popup.vue';

export default {
    name: "userinfo",
    data() {
        return {
            isEdit: false,
            // userinfo: {
            //     avatar: '',
            //     username: '阿斯顿啊是',
            //     phone: '15566668888',
            //     email: 'aaa@qq.com'
            // },
            username: '',
            email: '',
            phone: '',
            code: '',
            isLoading: false,
            isCodeLoading: false,
            countdown: 0,
            time: null,
            isShowAvatarEdit: false,
            image: '',
            cropper: null,
            avatar: '',
        };
    },
    computed: {
        ...mapState(['userinfo']),
    },
    components: {
        Loading,
        Popup
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {
        isShowAvatarEdit: {
            handler: function(val){
                if(val){
                    document.body.style.overflow = 'hidden';
                }else{
                    document.body.style.overflow = 'auto';
                }
            },
            immediate: true
        },
        userinfo: {
            handler: function (val) {
                if (val) {
                    this.resetForm();
                }
            },
            immediate: true
        },
        isEdit: {
            handler: function (val) {
                if (!val) {
                    // 取消编辑，重置表单
                    this.resetForm();
                }
            },
            immediate: true
        }
    },
    methods: {
        // 重置表单
        resetForm() { 
            this.username = this.userinfo.username;
            this.email = this.userinfo.email;
            this.phone = this.userinfo.phone;
            this.code = '';
        },
        // 设置倒计时
        setCountdown() { 
            this.countdown = 59;
            if(this.time) clearInterval(this.time);
            this.time = setInterval(() => {
                this.countdown--;
                if(this.countdown <= 0) clearInterval(this.time);
            }, 1000)
        },
        // 获取验证码
        getCode() { 
            if (this.isCodeLoading) { 
                return;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            this.isCodeLoading = true;
            this.$store.dispatch('getCode', {
                phone: this.phone,
                type: 4
            }).then((result) => {
                this.isCodeLoading = false;
                if (result.code == 100) {
                    this.setCountdown();
                    this.$showToast({ text: '验证码已发送' });
                } else if (result.code == 101) { 
                    this.$showToast({ text: '验证码发送失败' });
                } else if (result.code == 102) { 
                    this.$showToast({ text: '已发送验证码，请勿重复获取' });
                    this.setCountdown();
                }
            }).catch((err) => {
                this.isCodeLoading = false;
                this.$showToast({ text: '验证码发送失败' });
            });
        },
        // 修改
        submit() { 
            if (this.isLoading) {
                return;
            }
            if(this.username.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.username.focus();
                this.$showToast({ text: '请输入用户名' });
                return false;
            }
            if(this.email.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.email.focus();
                this.$showToast({ text: '请输入邮箱' });
                return false;
            }
            if(!(/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(this.email))){
                this.$refs.email.focus();
                this.$showToast({ text: '邮箱格式有误' }); //邮箱格式有误
                return false;
            }
            if(this.phone.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.phone.focus();
                this.$showToast({ text: '请输入手机号' });
                return false;
            }
            if(this.code.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.code.focus();
                this.$showToast({ text: '请输入验证码' });
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('editUserinfo', {
                username: this.username,
                email: this.email,
                phone: this.phone,
                code: this.code,
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) {
                    this.$showToast({ text: '修改成功' });
                    this.isEdit = false;
                    // 更新用户信息
                    this.$store.dispatch('getUserinfo');
                } else {
                    this.$showToast({ text: result.msg || '修改失败' });
                }
            }).catch((err) => {
                this.isLoading = false;
                this.$showToast({ text: '修改失败' });
            });
        },
        // 获取文件信息
        getFileData(){
            const file = this.$refs.file.files[0];
            // 读取文件
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (result) => { 
                this.image = reader.result;
                // 移动端打开弹窗
                this.isShowAvatarEdit = true;
            }
        },
        // 图片加载完成
        // cropper初始化
        cropperInit() {
            // 如果之前有，销毁
            if (this.cropper) this.cropper.destroy();
            // 构建实例
            this.cropper = new Cropper(this.$refs.image, {
                preview: this.$refs.preview,
                aspectRatio: 1,
                viewMode: 1,
                dragMode: 'move',
                cropBoxMovable: false,
                cropBoxResizable: false,
                toggleDragModeOnDblclick: false,
            });
        },
        // 保存头像
        uploadAvatar() { 
            const croppedCanvas = this.cropper.getCroppedCanvas({
                width: 300,
                height: 300
            });
            
            // base64
            // var croppedDataURL = croppedCanvas.toDataURL();
            // console.log(croppedDataURL);

            // 获取Blob对象
            croppedCanvas.toBlob((blob) => {
                // 上传
                let formData = new FormData();
                formData.append('image', blob);
                formData.append('token', localStorage.getItem('token'));
                this.$store.dispatch('uploadAvatar', formData).then((result) => {
                    this.$showToast({ text: '上传成功' });
                    // 关闭弹窗并销毁裁剪器
                    this.closeAvatarEdit();
                    // 更新用户信息
                    this.$store.dispatch('getUserinfo');
                }).catch((err) => {
                    this.$showToast({ text: '上传失败' });
                });;
            })
        },
        // 关闭弹窗
        closeAvatarEdit() { 
            this.isShowAvatarEdit = false;
            if (this.cropper) { 
                this.cropper.destroy();
                this.cropper = null;
            }
            this.image = '';
        },
    },
};
</script>

<template>
    <div class="userinfo">
        <p class="title only_pc">用户信息</p>
        <!-- 头像 -->
        <template v-if="userinfo && userinfo.avatar">
            <div class="avatar only_pc" @click="isShowAvatarEdit = true" :style="`background-image: url(${userinfo.avatar});`"></div>
            <div class="avatar only_mobile" @click="$refs.file.click()" :style="`background-image: url(${userinfo.avatar});`"></div>
        </template>
        <template v-else>
            <div class="avatar only_pc default" @click="isShowAvatarEdit = true"></div>
            <div class="avatar only_mobile default" @click="$refs.file.click()"></div>
        </template>
        <!-- 头像上传input -->
        <input type="file" ref="file" style="display: none;" @change="getFileData" accept="image/jpg,image/jpeg,image/png"/>
        <!-- 头像裁剪弹窗 -->
        <Popup class="popup avatar_edit" :show="isShowAvatarEdit" title="上传头像" :isShowClose="true" @close="closeAvatarEdit">
            <div class="btn_group flex only_pc">
                <div class="btn_submit layout_flex_center" @click="$refs.file.click()">上传图片</div>
            </div>
            <p class="text only_pc">支持jpg、jpeg、png 格式800*800的图片,需小于2M。</p>
            <template v-if="image">
                <div class="wrapper flex justify_between flex_wrap">
                    <div class="avatar_wrapper">
                        <img class="image" :src="image" ref="image" alt="" @load="cropperInit"/>
                    </div>
                    <div class="avatar_preview" ref="preview"></div>
                </div>
            </template>
            <div class="btn_group flex">
                <div class="btn_submit layout_flex_center" v-if="image" @click="uploadAvatar">保存</div>
                <div class="btn_submit layout_flex_center" @click="closeAvatarEdit">取消</div>
            </div>
        </Popup>
        <!--  -->
        <div class="form row" :class="{edit: isEdit}">
            <div class="item">
                <p class="name">用户名称：</p>
                <p class="text" v-if="!isEdit">{{ userinfo.username }}</p>
                <template v-else>
                    <input type="text" placeholder="请输入用户名" ref="username" v-model="username"/>
                    <p class="text r">*</p>
                </template>
            </div>
            <div class="item only_pc"></div>
            <div class="item">
                <p class="name">电子邮件：</p>
                <p class="text" v-if="!isEdit">{{ userinfo.email }}</p>
                <template v-else>
                    <input type="email" placeholder="请输入邮箱" ref="email" v-model="email"/>
                    <p class="text r">*</p>
                </template>
            </div>
            <div class="item">
                <p class="name">电话号码：</p>
                <p class="text" v-if="!isEdit">{{ userinfo.phone }}</p>
                <template v-else>
                    <input type="tel" placeholder="请输入手机号" ref="phone" v-model="phone" maxlength="11"/>
                    <p class="text r">*</p>
                </template>
            </div>
            <template v-if="isEdit">
                <div class="item only_pc"></div>
                <div class="item">
                    <p class="name">手机验证码：</p>
                    <input class="code" type="text" placeholder="请输入验证码" ref="code" v-model="code" maxlength="6"/>
                    <div class="btn_code layout_flex_center" v-if="isCodeLoading">
                        <Loading  type="smail"/>
                    </div>
                    <div class="btn_code layout_flex_center" v-else-if="countdown > 0">{{ countdown }}s</div>
                    <div class="btn_code layout_flex_center" @click="getCode" v-else>获取验证码</div>
                    <p class="text r">*</p>
                </div>
            </template>
        </div>
        <!-- 修改按钮 -->
        <div class="flex justify_end btn_bottom_group">
            <template v-if="isEdit">
                <div class="btn_submit layout_flex_center" @click="submit">
                    <template v-if="isLoading">
                        <Loading type="smail" color="#fff"/>
                    </template>
                    <template v-else>
                        确认修改
                    </template>
                </div>
                <div class="btn_submit layout_flex_center" @click="isEdit = false">取消</div>
            </template>
            <div class="btn_submit layout_flex_center" v-else @click="isEdit = true">修改</div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.userinfo{
    .avatar_edit{
        .in{
            padding: .6rem 1.2rem;
            @media screen and (max-width: 750px) {
                padding: .3rem;
            }
            .btn_group{
                gap: .2rem;
                @media screen and (max-width: 750px) {
                    gap: .3rem;
                    justify-content: center;
                }
            }
            .text{
                font-size: .16rem;
                padding: .2rem 0;
            }
            .image{
                width: 100%;
            }
            .wrapper{
                // gap: .2rem;
                margin-bottom: .2rem;
                @media screen and (max-width: 750px) {
                    display: block;
                }
            }
            .avatar_wrapper{
                width: 6rem;
                height: 6rem;
                @media screen and (max-width: 750px) {
                    width: 6.9rem;
                    height: 6.9rem;
                    margin-bottom: .3rem;
                }
            }
            .avatar_preview{
                width: 1rem;
                height: 1rem;
                border-radius: 50%;
                overflow: hidden;
                flex-shrink: 0;
                @media screen and (max-width: 750px) {
                    width: 1.3rem;
                    height: 1.3rem;
                    margin: 0 auto;
                }
            }
        }
    }
    .avatar{
        width: .9rem;
        height: .9rem;
        margin: 0 auto .6rem;
        border-radius: 50%;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        cursor: pointer;
        &.default{
            background-image: url('~@/assets/images/avatar.jpg');
        }
        @media screen and (max-width: 750px) {
            width: 1.3rem;
            height: 1.3rem;
            margin: 0 auto .8rem;
        }
    }
    .form{
        &.row{
            padding: 0 1rem;
            @media screen and (max-width: 750px) {
                padding: 0;
            }
        }
        &.edit{
            padding: 0;
        }
        .item{
            width: calc(50% - .1rem);
            @media screen and (max-width: 750px) {
                width: 100%;
            }
        }
    }
}
</style>